import React from 'react'

import aetnalogo from 'images/content/logo/aetna.jpeg'
import apexLogo from 'images/content/logo/apex.png'
import manhattanlifeLogo from 'images/content/logo/manhattanlife.png'
import cignaLogo from 'images/content/logo/cigna.jpeg'
import foresterLogo from 'images/content/logo/forester.jpeg'

import iaicLogo from 'images/content/logo/IAIC.png'
import kaiserLogo from 'images/content/logo/kaiser.jpeg'
import mutualOmahaLogo from 'images/content/logo/mutualOmaha.jpeg'
import palicLogo from 'images/content/logo/PALIC.jpeg'
import uhcLogo from 'images/content/logo/UHC.jpeg'


const SecondSection = () => {
  const carriers = [
    {
      image: aetnalogo,
      content: 'Aetna Health Insurance offers a wide range of medical, dental, vision, and behavioral health plans. It provides quality coverage and innovative solutions to meet the needs of its members. Aetna is committed to making healthcare more accessible and affordable for its members, with programs such as telemedicine and personalized support for Medicare beneficiaries.'
    },
    {
      image: apexLogo,
      content: 'Apex-MEC was formed to meet the complex needs of today’s healthcare industry. By partnering with consistent industry leaders, Apex-MEC provides a complete benefits solution for those seeking to neutralize the volatile healthcare marketplace. Apex-MEC offers industry-leading products because of established partnerships within the insurance industry, strategically meeting client needs in a changing benefits landscape.'
    },
    {
      image: manhattanlifeLogo,
      content: 'ManhattanLife is one of the oldest insurance companies in U.S. The Company’s longevity in the marketplace is remarkable considering the robust merger and acquisition activity the insurance industry has experienced in modern times. Operating successfully for 174 years as an independent is testimony to ManhattanLife’s enduring history, and it is an indicator of the reliability of our future.'
    },
    {
      image: cignaLogo,
      content: 'Cigna Health Insurance is a global health service company that offers health insurance plans for individuals and families. It improves the health and well-being of its members, with a focus on preventative care and disease management. Cigna is known for its innovative solutions and personalized approach to healthcare, with a range of tools and resources designed to help its members live healthier, happier lives.'
    },
    {
      image: foresterLogo,
      content: 'Foresters Financial Health Insurance offers plans designed to meet the needs of individuals and families. The company has a particular emphasis on preventative care and wellness. Foresters Financial is known for its personalized approach to healthcare, with a range of tools and resources designed to help its members achieve their health and financial goals throughout every stage of their lives.'
    },

    {
      image: iaicLogo,
      content: 'Independent American Insurance Is known for providing affordable and flexible coverage options, with a focus on personalized service and support. It offers an array of insurance solutions and prides itself on top-rated customer satisfaction. Members can take advantage of a range of tools to make the most informed decisions about the right healthcare coverage based on specialized needs.'
    },
    {
      image: kaiserLogo,
      content: 'Kaiser Permanente is a leading health insurance provider that offers a range of health plans for individuals and families. The company fosters an integrated approach to healthcare, with a focus on preventative care and wellness. Whether you are just getting started with coverage or need to update your plan, Kaiser ensures you get the coverage you need.'
    },
    {
      image: palicLogo,
      content: 'Philadelphia American Health Insurance is known for its financial strength and stability. The company is backed by New Era Life Insurance Company, which has been providing reliable insurance coverage for more than 90 years. This financial stability ensures that members can rely on Philadelphia American Health Insurance to provide consistent, high-quality coverage over the long term.'
    },
    {
      image: uhcLogo,
      content: 'United Healthcare is known for its focus on preventative care and wellness. It offers a range of wellness programs, including health assessments, coaching, and support. United Healthcare members benefit from a vast network of providers, innovative coverage options, commitment to preventative care and wellness, and focus on technology and innovation at every phase of coverage.'
    },
  ]
  return (
    <>
      <div className='text-2xl sm:text-4xl font-bold text-center'>Health Insurance Carriers Nationwide</div>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-12'>
        {
          carriers.map((carrier, index) => {
            const isLastAndOdd = carriers.length % 2 !== 0 && index === carriers.length - 1;

            return (
              <div
                className={`flex flex-col items-center justify-center ${isLastAndOdd ? 'md:col-span-2' : ''}`}
                key={carrier.image}
              >
                <div className='max-w-52 h-24 flex items-end'>
                  <img className='max-h-20' alt='sample' src={carrier.image} />
                </div>
                <p className='max-w-2xl'>{carrier.content}</p>
              </div>
            );
          })
        }
      </div>
    </>
  )
}

export default SecondSection